import BaseAPIService from '@/services/baseAPIService'

export default class ReportingAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }


  // Reports are used by generating a signed url link so the PDF can be downloaded without an Auth header directly
  // Temporary access links expire after a couple hours
  generateReportSignedURL(url) {
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${url}` })
  }
}